// This icon file is generated automatically.
var PtoBookOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 32 32", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M26 2H6a1 1 0 00-1 1v26a1 1 0 001 1h20a1 1 0 001-1V3a1 1 0 00-1-1zm-8.13 2.25h3v6.56l-1.45-1.06-1.55 1.1v-6.6zm6.88 23.5H7.25V4.25H16v9.28c0 .1.03.2.1.29a.5.5 0 00.7.11l2.6-1.87 2.55 1.86c.09.06.2.1.3.1a.5.5 0 00.5-.5V4.25h2v23.5z", "fill-rule": "nonzero" } }] }, "name": "pto-book", "theme": "outlined" };
export default PtoBookOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PtoBookOutlined.js
// module id = 3881
// module chunks = 0